import {
  getPlayerCountryMetricValue,
  isOthersMarketRow,
} from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/Stats/SteamSales/_config/_utils';

const PLAYER_COUNTRY_OTHERS_THRESHOLD_PERCENT = 0.1;

export const mergeSmallPlayerCountriesIntoOthers = (
  list: any[],
  primaryMetricName: string,
): any[] => {
  if (!Array.isArray(list) || list.length === 0) return list || [];
  if (!primaryMetricName) return list;

  const regular: any[] = [];
  const toMerge: any[] = [];

  list.forEach((item) => {
    if (isOthersMarketRow(item?.market)) {
      toMerge.push(item);
      return;
    }
    if (
      getPlayerCountryMetricValue(item, primaryMetricName) <
      PLAYER_COUNTRY_OTHERS_THRESHOLD_PERCENT
    ) {
      toMerge.push(item);
    } else {
      regular.push(item);
    }
  });

  if (toMerge.length === 0) return regular;

  const mergedMetricsMap: Record<
    string,
    { name: string; value: number; dod: any }
  > = {};
  toMerge.forEach((item) => {
    const metrics = Array.isArray(item?.metrics) ? item.metrics : [];
    metrics.forEach((m: any) => {
      const name = m?.name;
      if (!name) return;
      if (!mergedMetricsMap[name]) {
        mergedMetricsMap[name] = { name, value: 0, dod: null };
      }
      const val = Number(m?.value);
      if (Number.isFinite(val)) {
        mergedMetricsMap[name].value += val;
      }
    });
  });

  const othersRow: any = {
    market: 'others',
    name: 'Others',
    name_cn: '其他',
    metrics: Object.values(mergedMetricsMap),
  };

  return [...regular, othersRow];
};
